import React, { lazy, Suspense } from 'react';
import { Loading } from '../../components';
const GwpRedemption = lazy(() => import('./gwpRedemptionForm'));

export function GwpRedemptionLazy(props) {
  return <div>
    <Suspense fallback={<Loading />}>
      <GwpRedemption />
    </Suspense>
  </div>
}
